import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./styles/form.module.css";
import Form from "./components/Form";
import img1 from "./images/formImg1.jpg";
import img2 from "./images/formImg2.jpg";
import img3 from "./images/formImg3.jpg";
import img4 from "./images/formImg4.jpg";
import img5 from "./images/formImg5.jpg";
import img6 from "./images/formImg6.jpg";
import { FadeIn, FadeInUp } from "@/shared/ui/animations";
import useDiamondBounce from "./hooks/useDiamondBounce.jsx";


const FormSection = () => {
    const location = useLocation();

    useDiamondBounce(".imgForm", "#form-section form");

    useEffect(() => {
        if (location.hash === "#form-section") {
            const el = document.getElementById("form-section");
            if (el) el.scrollIntoView({ behavior: "smooth" });
        }
    }, [location]);

    return (
        <>
            <section id="form-section" className={`${styles.formSection} my-0 position-relative`}>
                <FadeIn delay={500}>
                    {/* 👇 добавлен обычный класс 'imgForm' для поиска через JS */}
                    {/* слева четыре: l0 • l1 • l2 • l3 */}
                    <img src={img1} className="imgForm" data-diamond="l0" alt={""}/>
                    <img src={img2} className="imgForm" data-diamond="l1" alt={""}/>
                    <img src={img3} className="imgForm" data-diamond="l2" alt={""}/>

                    {/* справа четыре: r0 • r1 • r2 • r3 */}
                    <img src={img5} className="imgForm" data-diamond="r1" alt={""}/>
                    <img src={img4} className="imgForm" data-diamond="r2" alt={""}/>
                    <img src={img6} className="imgForm" data-diamond="r0" alt={""}/>

                </FadeIn>

                <div className={`container-custom my-0 ${styles.formWrapper}`}>
                    <FadeInUp>
                        <p className="par1">Время стать легендой</p>
                        <p className="par2">начни своё приключение уже сегодня</p>
                    </FadeInUp>
                </div>

                {/*<FadeIn delay={200}>*/}
                {/*    <p className={`${styles.formText} body text-center mt-3 mx-auto`}>*/}
                {/*        Если Вы хотите оставить заявку на <br /> “Закрытую игру”, нажмите{" "}*/}
                {/*        <span*/}
                {/*            className={`body-bold ${styles.popupLink}`}*/}
                {/*            onClick={() => setPopupOpen(true)}*/}
                {/*        >*/}
                {/*          здесь*/}
                {/*        </span>*/}
                {/*    </p>*/}
                {/*</FadeIn>*/}

                <Form/>
            </section>

        </>
    );
};

export default FormSection;
